import { productAPI, common } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData } from '@/common/utils/ServiceSupport';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import store from '@/store';

export default {
  async fetchAdminProductList({ commit, state, rootGetter }, payload) {
    const { page, limit, totalPage } = state;
    if (page > totalPage) return;

    if (payload.storeCategoryNo || payload.searchText) {
      const { status, data } = await ServiceExec.get(
        productAPI.product_list,
        payload
      );

      commit('setInitAdminProductList', data.list);
      commit('setPage', payload.page + 1);
      commit('setTotalPage', data.pageInfo?.totalPage ?? 2);
    } else {
      const { status, data } = await ServiceExec.get(productAPI.product_list, {
        page: page,
        limit: limit,
        ...payload
      });
      commit('setPage', page + 1);
      commit('setTotalPage', data.pageInfo?.totalPage ?? 2);
      commit('setAdminProductList', data.list ?? []);
    }
  },

  async fetchMyProductCategoryList({ commit }, payload) {
    // const { status, data } = await ServiceExec.get(
    //   productAPI.product_list,
    //   payload
    // );

    const { status, data } = await ServiceExec.get(
      common.productCategoryList,
      payload
    );

    if (status === 200) {
      commit('setProductCategoryList', data);
      // const { list } = data;
      // const categoryItems = list.map((item) => item.category);
      //
      // const uniqueList = [];
      // const uniqueKeys = new Set();
      //
      // categoryItems.forEach((obj) => {
      //   const key = obj.productCategoryNo;
      //
      //   if (!uniqueKeys.has(key)) {
      //     uniqueKeys.add(key);
      //     uniqueList.push(obj);
      //   }
      // });

      // return uniqueList;
    }
  },

  async getProductDetail({ commit }, productNo) {
    const { status, data } = await ServiceExec.get(
      productAPI.product_detail(productNo)
    );

    if (status === 200) commit('setProductDetail', data);
  },

  async productSave({ commit }, payload) {
    const { status, data } = await ServiceExec.post(
      productAPI.product_save,
      asFormData(payload)
    );

    if (status === 200) return data;
  },

  async productDelete({ commit }, productNo) {
    const { data, status } = await ServiceExec.delete(
      productAPI.product_delete(productNo)
    );

    if (status === 200) return data;
  }
};
